import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from 'luxon';
import {BehaviorSubject} from 'rxjs';

// This pipe & service function convert values to Eastern STANDARD time OR Eastern DAYLIGHT time.
export const transformDateService = (value: string): string | BehaviorSubject<string> => {
    // This service function is the same as the pipe function. This allows us to transform dates programmatically when
    // that makes more sense than using a pipe in the HTML template.
    const date = new Date(value);
    return DateTime.fromISO(date.toISOString()).setZone('America/New_York').toFormat('MM/dd/yyyy hh:mm a');
}

@Pipe({
    name: 'formatTimezone',
    standalone: true
})
export class FormatTimezonePipe implements PipeTransform {
    transform(value: string): string | BehaviorSubject<string> {
        const date = new Date(value);
        return DateTime.fromISO(date.toISOString()).setZone('America/New_York').toFormat('MM/dd/yyyy hh:mm a');
    }
}
